import Box from "@mui/material/Box";
import Divider from "@mui/material/Divider";
import Stack from "@mui/material/Stack";
import {useState} from "react";
import {
    RightSidebarRail,
    RightSidebarRailLayout,
} from "../layout/rightSidebar/RightSidebarRail";
import {InsightsRailSearch, matchesTitle} from "./kit/InsightsRailSearch";
import MarketingOverviewTab from "./marketing/MarketingOverviewTab";

/** Same cap as the other insights pages, so every module centres its content identically. */
const CONTENT_MAX_WIDTH = 1440;

/**
 * Marketing insights. Everything here reads the guest base as it stands today rather than a window
 * of it, so the rail carries the title search and nothing else — no range, no comparison.
 */
export function MarketingInsights() {
    const [query, setQuery] = useState("");
    const [isContentScrolled, setIsContentScrolled] = useState(false);

    return (
        <RightSidebarRailLayout>
            <Divider sx={{borderColor: isContentScrolled ? "divider" : "transparent"}}/>

            <Box
                onScroll={event => setIsContentScrolled(event.currentTarget.scrollTop > 0)}
                sx={{
                    flex: 1,
                    minWidth: 0,
                    minHeight: 0,
                    overflowY: "auto",
                    pt: {xs: 2, md: 3},
                    pb: {xs: 6, md: 9},
                    px: {xs: 2, md: 3},
                }}
            >
                <Stack sx={{width: "100%", maxWidth: CONTENT_MAX_WIDTH, mx: "auto", minWidth: 0}}>
                    <MarketingOverviewTab matches={(title, key) => matchesTitle(query, title, key)}/>
                </Stack>
            </Box>

            <RightSidebarRail>
                <InsightsRailSearch query={query} onQueryChange={setQuery}/>
            </RightSidebarRail>
        </RightSidebarRailLayout>
    );
}

export default MarketingInsights;
